<template>
  <div class="pt-4 pb-24 px-4">
    <h3 class="text-3xl font-semibold mb-5">
      {{ $t('how_can_help_you') }}
    </h3>

    <div class="mb-4">
      <input
          v-model="searchQuery"
          type="text"
          :placeholder="`${$t('search')}...`"
          class="block w-full rounded-full border-0 py-2 ring-0 ring-inset focus:ring-1 focus:ring-inset"
          :class="[
              $theme.inputBg,
              $theme.inputRingColor,
              $theme.baseTextColor,
              $theme.inputRingFocusColor,
              $theme.inputPlaceTextColor,
              $theme.tabTextColor,
          ]"
      />
    </div>

    <template v-if="loading">
      <div class="rounded-xl">
        <LoadingBlock />
      </div>
    </template>

    <template v-else>
      <template v-if="showItem">
        <div class="rounded-xl mb-4 py-3">
          <div class="border-b pb-2 mb-2" :class="[$theme.cardBorderColor]">
            <button @click="onBack" type="button" class=" flex items-center font-medium">
              <ChevronLeftIcon class="w-5 mr-2" />
              <span>{{ showCategoryTitle }}</span>
            </button>
          </div>
          <div class="text-sm">
            <div class="font-semibold" v-html="highlightText(showItem.question, searchQuery)"></div>
            <RenderHtml :content="highlightText(showItem.answer, searchQuery)" />
          </div>
        </div>
      </template>

      <template v-else>
        <div v-for="category in filteredCategories" :key="category.id">
          <div v-if="category.items.length > 0" class="rounded-xl mb-4 py-3">
            <div class="text-lg font-medium pb-2 mb-2" v-html="highlightText(category.title, searchQuery)"></div>
            <div
              v-for="(item, itemIdx) in category.items"
              :key="item.id"
              :class="[
                'border-t py-3',
                itemIdx !== 0 ? $theme.cardBorderColor : ''
              ]"
            >
              <a @click="onShowItem(category.title, item)" href="javascript:void(0)" class="relative flex justify-between w-full pr-10 font-medium" :class="[$theme.tabTextColor]">
                <span v-html="highlightText(item.question, searchQuery)"></span>
                <ArrowUpIcon class="w-5 absolute right-0 top-1" :class="[$theme.IconSvgColor]" />
              </a>
            </div>
          </div>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import ArrowUpIcon from '@/assets/icons/ArrowUpIcon.vue'
import LoadingBlock from '@/components/LoadingBlock.vue'
import { ChevronLeftIcon } from "@heroicons/vue/24/outline";
import RenderHtml from "@/components/elem/RenderHtml.vue";
import { addBackButton, hideBackButton } from "@/helpers/telegramHelper";

export default {
  components: {
    LoadingBlock,
    ArrowUpIcon,
    ChevronLeftIcon,
    RenderHtml
  },

  data() {
    return {
      faq: null,
      loading: true,
      showItem: null,
      showCategoryTitle: '',
      searchQuery: '',
    }
  },

  computed: {
    filteredCategories() {
      if (!this.faq) return [];
      const query = this.searchQuery.toLowerCase();
      return this.faq.filter(category =>
          category.title.toLowerCase().includes(query) ||
          category.items.some(item => item.question.toLowerCase().includes(query))
      );
    }
  },

  methods: {
    onLoadFaq() {
      this.$api.get('/faq').then(result => {
        console.log('result', result.data)
        this.faq = result.data;
        this.loading = false;
      })
    },

    onBack() {
      this.showCategoryTitle = '';
      this.showItem = null;
    },

    onShowItem(categoryTitle, item) {
      this.showCategoryTitle = categoryTitle;
      this.showItem = item;
      console.log(this.showItem);
    },

    highlightText(text, query) {
      if (!text || typeof text !== 'string') return text;
      if (!query) return text;
      const regex = new RegExp(`(${query})`, 'gi');
      return text.replace(regex, '<mark>$1</mark>');
    }
  },

  mounted() {
    this.onLoadFaq();
    addBackButton(this.$router);
  },

  beforeUnmount() {
    hideBackButton();
  }
}
</script>
